import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { NotificationMenuService } from '../services/notification-menu.service';

@Component({
  selector: 'app-notification-icon',
  templateUrl: './notification-icon.component.html',
  styleUrls: ['./notification-icon.component.scss']
})
export class NotificationIconComponent implements OnInit {
  unSeenCount: Observable<number>;
  matHidden = false;

  constructor(private notificationMenuService: NotificationMenuService) { }

  ngOnInit() {
    this.unSeenCount = this.notificationMenuService.unSeenCountSubject.asObservable();
    this.notificationMenuService.unSeenCountSubject.subscribe(value => {
      this.matHidden = value === 0;
    });
  }
}
